import React from 'react';

/** Standard FMR Digital attribution footer, shared across FMR Digital properties. */
export function Footer(): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-800 bg-slate-950/80 py-4 px-6 text-center">
      <p className="text-[11px] text-slate-500">
        HookHouse Pro is a product of{' '}
        <a
          href="https://fmrdigital.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-400 hover:text-accent transition-colors"
        >
          FMR Digital LLC
        </a>
        {' '}© {year} FMR Digital LLC · All rights reserved.
      </p>
    </footer>
  );
}
